import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonSharedModule } from '../common/shared.module';
import { AllIncentivesComponent } from './all-incentives/all-incentives.component';
import { DealAssociationDocumentQueueComponent } from './deal-association-document-queue/deal-association-document-queue.component';
import { ExceptionDisputeRequestsComponent } from './exception-dispute-requests/exception-dispute-requestscomponent';
import { IncentiveCountComponent } from './incentive-count/incentive-count.component';

@Component({
  selector: 'app-advisor-incentives',
  templateUrl: './advisor-incentives.component.html',
  styleUrls: ['./advisor-incentives.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    IncentiveCountComponent,
    DealAssociationDocumentQueueComponent,
    ExceptionDisputeRequestsComponent,
    AllIncentivesComponent
  ]
})
export class AdvisorIncentivesComponent implements OnInit {
  tabList!: HomeTabDetailsModel[];

  get isProdEnvironment(): boolean {
    return environment.isProdEnvironment;
  }

  ngOnInit() {
    this.tabList = [
      new HomeTabDetailsModel(true, true),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel()
    ];
  }

  get isEngagmentCountSelected(): boolean {
    return this.tabList[0].isTabSelected;
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
    });
    this.tabList[event.index].hasTabLoaded = true;
    this.tabList[event.index].isTabSelected = true;
  }
}

export class HomeTabDetailsModel {
  hasTabLoaded: boolean;
  isTabSelected: boolean;

  constructor(hasTabLoaded = false, isTabSelected = false) {
    this.hasTabLoaded = hasTabLoaded;
    this.isTabSelected = isTabSelected;
  }
}
